// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"31d53a5b","592":"de09dede","984":"3508831c"}[chunkId] + ".chunk.js";
};